


<template>
  <div class="stack_active_set_B">
    

    <div class="box manage">
      <div class="header"> <h2> 추천 관리고객</h2> </div>
      <div class="chapter">
        <span>관리가 필요한 사람</span>
        <select class="select" v-model="manage_filter">
          <option value="1">최신순</option>
          <option value="2">기타순</option>
        </select>
      </div>
      <ul>
        <li v-for="(item, index) in manage_list" :key="index"> <img :src="item.thumb"/> <p>{{item.msg}}</p> </li>
      </ul>
    </div>


    <div class="stacks">
      
      
      <div class="stack roulette">
        <div class="header"> <h2>📝 행운의 룰렛</h2> </div>
        <div class="content">
          <div class="description">
            <h2>보유 선물 <b>10개</b></h2>
            <p>룰렛권 <b>10장</b></p>
          </div>
          <img src="https://www.buybullion24.co.uk/dynamicdata/prod_images/1168.png"/>
        </div>
      </div>
      

      <div class="stack roulette-winner">
        <div class="header"> <h2>📝 당첨되신 분들</h2> </div>
        <ul>
          <li v-for="(item, index) in winner_list" :key="index"><img :src="item.thumb"/> <p>{{item.name}}</p> <p>{{item.date}}</p> <p>{{item.gift}}</p> </li>
        </ul>
      </div>


    </div>


    <div class="box active-checker">
      <div class="header"> <h2>🏃 표준활동 체크</h2> <h2>😀 😡</h2> </div>
      <div class="chapter">
        <h2>멘토 평가</h2>
        <span>성실</span>
      </div>
      <div class="chart">
        <div class="bar-group">
          <div class="bar" style="height: 52%"></div>
          <span>1월</span>
        </div>
        <div class="bar-group">
          <div class="bar" style="height: 42%"></div>
          <span>2월</span>
        </div>
        <div class="bar-group">
          <div class="bar warning" style="height: 44%"></div>
          <span>3월</span>
        </div>
        <div class="bar-group">
          <div class="bar" style="height: 40%"></div>
          <span>4월</span>
        </div>
        <div class="bar-group">
          <div class="bar" style="height: 16%"></div>
          <span>5월</span>
        </div>
      </div>
      <div class="content">
        <span>활동점수 <b>1,754</b>점</span>
        <span>근태점수 <b>80</b>점</span>
        <span>표준활동 <b>77</b>%</span>
      </div>
    </div>

    
  </div>
</template>




<script>
export default {
  data() {
    return {
      manage_filter:'1',
      manage_list:[
        { thumb:"https://i.namu.wiki/i/ODE_pmT0eo5wvZ2JtV4yBwiiWfxBtaSWTid5bV__iwtCkBKEos7mh4bQHHaBGswf_FS5HWL1eukLW7Xqn4yTRQ.webp", msg:"🍰 '정우성' 고객님이 1일 뒤 생일입니다." },
        { thumb:"https://i.namu.wiki/i/mqJyzeTqAZUS9f4GzqgNEFcRGiPLyo-DcDKzWbMIAq4Mx7NbEnGdbl75kSClKdDRzsHe5SFyXqNQyk-I_LLJpg.webp", msg:"💸 '강동원' 고객님이 미납 5일째 입니다." },
        { thumb:"https://i.namu.wiki/i/ZnBMAAGJaiFKqDmASXCt-977Xuq6gLA-G8AsD4K1BKCVBEzrjISoW9QyfcSKPnacwuBpCGSSyBtCJv8E-UocNQ.webp", msg:"🎁 '차은우' 고객님에게 밀린 1개 선물이 있습니다." },
      ],
      winner_list:[
        {name:"김우인", thumb:"https://image-cdn.hypb.st/https%3A%2F%2Fkr.hypebeast.com%2Ffiles%2F2023%2F10%2Fstarbucks-korea-introduces-refund-policy-for-difference-in-gift-cards-01.jpg?q=75&w=800&cbr=1&fit=max", date:"20250430", gift:"스타벅스 아아세트"},
        {name:"박재희", thumb:"https://image-cdn.hypb.st/https%3A%2F%2Fkr.hypebeast.com%2Ffiles%2F2023%2F10%2Fstarbucks-korea-introduces-refund-policy-for-difference-in-gift-cards-01.jpg?q=75&w=800&cbr=1&fit=max", date:"20250430", gift:"스타벅스 아아세트"},
        {name:"김주헌", thumb:"https://image-cdn.hypb.st/https%3A%2F%2Fkr.hypebeast.com%2Ffiles%2F2023%2F10%2Fstarbucks-korea-introduces-refund-policy-for-difference-in-gift-cards-01.jpg?q=75&w=800&cbr=1&fit=max", date:"20250430", gift:"스타벅스 아아세트"},
      ]
    }
  },
  methods: {
    clicked() {
    }
  }
}
</script>




<style scoped>

@media (max-width: 1024px) or (max-height: 800px) {
  .stack_active_set_B {
    grid-template-columns: repeat(1, 1fr) !important;
    grid-template-rows : repeat(3, 1fr) !important;
    height:fit-content !important;
    padding:16px;
    box-sizing: border-box;
  }
}

ul {
  list-style: none;
  padding:0;
  margin:0;
}

h2 {
  font-size: 16px;
  font-weight: 600;
  padding:0;
  margin:0;
}

p {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
}

.stack_active_set_B {
  width: 100%;
  height: 38vh;
  display: grid;
  gap:24px;
  grid-template-columns: repeat(3, 1fr);
}

.box {
  width:100%;
  height:100%;
  background: var(--color-surface);
  border-radius: 16px;
  padding:16px;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap:12px;
  backdrop-filter: blur(24px);
  overflow:hidden;
}

.header {
  width:100%;
  height:30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header > h2 {
  font-size: 20px;
  font-weight: 600;
  padding:0;
  margin:0;
}

.header > span {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
  cursor: pointer;
}

.header > button {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
  cursor: pointer;
  background: var(--color-brand);
  color: var(--color-text-primary);
  border-radius: 8px;
  border:none;
  padding:8px 16px;
}

.header small {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
  margin-left: 6px;
}

.stacks {
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  gap:24px;
}

.stacks > .stack {
  width: 100%;
  height: 100%;
  flex:1;
  background: var(--color-surface);
  border-radius: 16px;
  padding:16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: start;
  gap:12px;
  flex-direction: column;
  backdrop-filter: blur(24px);
}

.stacks > .stack.roulette > .content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap:12px;
}

.stacks > .stack.roulette-winner > ul {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap:12px;
}

.stacks > .stack.roulette-winner > ul > li {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  gap:12px;
}

.stacks > .stack.roulette-winner > ul > li > img {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  object-fit: cover;
}

.stacks > .stack.roulette-winner > ul > li > p {
  width:fit-content;
  overflow:hidden;
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
}

.stacks > .stack.roulette > .content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap:12px;
}

.stacks > .stack.roulette > .content > .description {
  flex:1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:12px;
}

.stacks > .stack.roulette > .content > .description > h2 {
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  padding:0;
  margin:0;
  color: var(--color-brand);
}

.stacks > .stack.roulette > .content > .description > p {
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  padding:0;
  margin:0;
  color: var(--color-text-primary);
}

.stacks > .stack.roulette > .content > .description b {
  font-size: 20px;
  font-weight: 800;
  padding:0;
  margin:0;
}

.stacks > .stack.roulette > .content > img {
  width: 30%;
  aspect-ratio: 1/1;
  border-radius: 16px;
  object-fit: cover;
}

.chapter {
  width: 100%;
  display:flex;
  margin:0;
  font-size: 14px;
  font-weight: 400;
  list-style: none;
  justify-content: space-between;
  align-items: center;
}

.chapter > ul {
  width: 100%;
  display:flex;
  padding:0;
  margin:0;
  list-style: none;
  gap:24px;
}

.chapter > p {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  padding:0;
  margin:0;
  color: var(--color-text-primary);
  cursor: pointer;
}

.manage > ul {
  width: 100%;
  display:flex;
  flex-direction: column;
  padding:0;
  margin:0;
  list-style: none;
  gap:12px;
}

.manage > ul > li {
  width: 100%;
  display:flex;
  justify-content: start;
  align-items: center;
  padding:0;
  margin:0;
  list-style: none;
  gap:6px;
  background: var(--color-surface-reverse);
  padding:6px;
  border-radius:12px;
  box-sizing: border-box;
}

.manage > ul > li > img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.manage > ul > li > p {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
}

.active-checker > .chart {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap:12px;
}

.active-checker > .chart > .bar-group {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  gap:12px;
}

.active-checker > .chart > .bar-group > span {
  font-size: 14px;
  font-weight: 400;
  padding:0;
  margin:0;
}

.active-checker > .chart > .bar-group > .bar {
  width:24px;
  background: var(--color-brand);
  border-radius: 6px;
}

.active-checker > .chart > .bar-group > .bar.warning {
  background: var(--color-special-warning);
}

.active-checker > .content {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  font-size: 16px;
  font-weight: 400;
  gap:12px;
}

.active-checker > .content > span {
  width: 100%;
  display: flex;
  align-items: center;
  gap:12px;
}

.active-checker > .content > span > b {
  font-size: 20px;
  font-weight: 800;
  padding:0;
  margin:0;
}

</style>
